document.addEventListener('DOMContentLoaded', function () {
    const reloadDelay = 2000; // 1000ms (1 second) before reloading the page
    const debounceDelay = 1000; // The delay in milliseconds (e.g., 500ms = 0.5 seconds)
    let debounceTimer;

    // Function to update the real input based on the visual input
    function updateRealInputFromVisual(visualInput) {
        const realInput = visualInput.closest('.cart__item').querySelector('.fabric-real-input');
        
        if (realInput) {
            const visualValue = parseFloat(visualInput.value);
            console.log('visualValue', visualValue);

            if (!isNaN(visualValue)) {
                // Multiply the visual input value by 10 and update the real input
                realInput.value = Math.round(visualValue * 10); // Round to the nearest integer
            }
        }
    }

    // Function to trigger the event with debounce
    function triggerRealInputUpdate(visualInput) {
        // Clear the previous debounce timer
        clearTimeout(debounceTimer);

        // Set a new debounce timer
        debounceTimer = setTimeout(function () {
            // Update the real input when typing has stopped
            updateRealInputFromVisual(visualInput);

            // Trigger the input event on the real input (to simulate user interaction)
            const realInput = visualInput.closest('.cart__item').querySelector('.fabric-real-input');
            if (realInput) {
                const event = new Event('input', {
                    'bubbles': true,
                    'cancelable': true
                });
                realInput.dispatchEvent(event);
            }

            // Wait for 1 second after the event and then reload the page
            setTimeout(function () {
              window.location.href = '/cart';
            }, reloadDelay); // Reload after 1 second
        }, debounceDelay); // Debounce for 500ms before dispatching
    }

    // Event delegation: Listen for inputs on visual inputs
    document.body.addEventListener('blur', function (event) {
        if (event.target && event.target.classList.contains('visual-fabric-input')) {
            console.log('User has clicked out of the input');
            triggerRealInputUpdate(event.target); // Call the debounce function or trigger the update
        }
    }, true);

    document.body.addEventListener('keydown', function (event) {
        if (event.target && event.target.classList.contains('visual-fabric-input') && event.key === 'Enter') {
            console.log('User pressed Enter');
            event.preventDefault();
            triggerRealInputUpdate(event.target); // Call the debounce function or trigger the update
        }
    }, true);
});


document.addEventListener('DOMContentLoaded', function () {
  // Function to wait for an element to appear
  function waitForElement(selector, callback) {
    const interval = setInterval(function () {
      const element = document.querySelector(selector);
      if (element) {
        clearInterval(interval);
        callback(element);
      }
    }, 100); // Check every 100ms
  }

  // Wait for cart toggle button to appear
  waitForElement('.cart__toggle', function (cartDrawerToggle) {
    console.log('Cart drawer toggle found');

    // Add event listener to the cart drawer toggle button
    cartDrawerToggle.addEventListener('click', function () {
      // Add a delay before looking for the cart items
      setTimeout(function () {
        // Wait for the cart drawer items to appear after the delay
        waitForElement('.cart-drawer__items', function (cartDrawerItems) {
          const cartItems = cartDrawerItems.querySelectorAll('.cart__item'); // Get all cart items

          // Initialize the matched products list
          const matchedProducts = [];

          // Loop over cart items to collect matched products
          cartItems.forEach(function (cartItem) {
            const cartItemProperties = cartItem.querySelector('.cart__item__properties');
            if (cartItemProperties) {
              const matchedProductDiv = cartItemProperties.querySelector('[data-matched-product]');
              if (matchedProductDiv) {
                const matchedProductTitle = matchedProductDiv.getAttribute('data-matched-product'); // Get matched product title
                if (matchedProductTitle) {
                  matchedProducts.push(matchedProductTitle); // Add to the list
                }
              }
            }
          });

          console.log('Matched products in cart:', matchedProducts);

          cartItems.forEach(function (cartItem) {
            const cartItemTitle = cartItem.querySelector('.cart__item__title a');
            const matchedButton = cartItem.querySelector('.matched-thread button');
            const bestMatchAddedSpan = cartItem.querySelector('.best-match-added');
            const bestMatchAddSpan = cartItem.querySelector('.best-match-add');

            if (cartItemTitle) {
              const parentProductTitle = cartItemTitle.textContent.trim(); // Get the product title from cart item

              // Check if the current cart item's title matches any matched product title
              if (matchedProducts.includes(parentProductTitle)) {
                if (bestMatchAddedSpan) {
                  bestMatchAddedSpan.style.display = 'inline';
                }
                if (bestMatchAddSpan) {
                  bestMatchAddSpan.style.display = 'none';
                }
                if (matchedButton) {
                  matchedButton.classList.add('active');
                }
              } else {
                if (bestMatchAddedSpan) {
                  bestMatchAddedSpan.style.display = 'none';
                }
                if (bestMatchAddSpan) {
                  bestMatchAddSpan.style.display = 'inline';
                }
                if (matchedButton) {
                  matchedButton.classList.remove('active');
                }
              }
            }
          });
        });
      }, 500); // Wait for 500ms before looking for cart items
    });
  });

});

document.addEventListener('DOMContentLoaded', function () {
  function waitForElement(selector, callback) {
    const interval = setInterval(function () {
      const element = document.querySelector(selector);
      if (element) {
        clearInterval(interval);
        callback(element);
      }
    }, 100); // Check every 100ms
  }
  // Event delegation: Listen for click events on the document body
  document.body.addEventListener('click', function(event) {
    // Log the clicked element for debugging
    console.log("Clicked element:", event.target);


     if(event.target && event.target.closest('button')) {
      const addtocartbutton = event.target.closest('button');
      console.log('addtocartbutton', addtocartbutton);
      setTimeout(function () {
            // Wait for the cart drawer items to appear after the delay
        waitForElement('.cart-drawer__items', function (cartDrawerItems) {
              const cartItems = cartDrawerItems.querySelectorAll('.cart__item'); // Get all cart items
              console.log('Cart items in drawer:', cartItems);
    
              // Initialize the matched products list
              const matchedProducts = [];
    
              // Loop over cart items to collect matched products
              cartItems.forEach(function (cartItem) {
                const cartItemProperties = cartItem.querySelector('.cart__item__properties');
                if (cartItemProperties) {
                  const matchedProductDiv = cartItemProperties.querySelector('[data-matched-product]');
                  if (matchedProductDiv) {
                    const matchedProductTitle = matchedProductDiv.getAttribute('data-matched-product'); // Get matched product title
                    if (matchedProductTitle) {
                      matchedProducts.push(matchedProductTitle); // Add to the list
                    }
                  }
                }
              });
    
              console.log('Matched products in cart:', matchedProducts);
    
              cartItems.forEach(function (cartItem) {
                const cartItemTitle = cartItem.querySelector('.cart__item__title a');
                const matchedButton = cartItem.querySelector('.matched-thread button');
                const bestMatchAddedSpan = cartItem.querySelector('.best-match-added');
                const bestMatchAddSpan = cartItem.querySelector('.best-match-add');
                
    
                if (cartItemTitle) {
                  const parentProductTitle = cartItemTitle.textContent.trim(); // Get the product title from cart item
                  
    
                  // Check if the current cart item's title matches any matched product title
                  if (matchedProducts.includes(parentProductTitle)) {
                    if (bestMatchAddedSpan) {
                      bestMatchAddedSpan.style.display = 'inline';
                    }
                    if (bestMatchAddSpan) {
                      bestMatchAddSpan.style.display = 'none';
                    }
                    if (matchedButton) {
                      matchedButton.classList.add('active');
                      console.log('bestMatchAddedSpan', parentProductTitle, bestMatchAddedSpan, bestMatchAddSpan, matchedButton)

                    }
                  } else {
                    console.log('doesnotinclude', parentProductTitle, bestMatchAddedSpan, bestMatchAddSpan)
                    if (bestMatchAddedSpan) {
                      bestMatchAddedSpan.style.display = 'none';
                    }
                    if (bestMatchAddSpan) {
                      bestMatchAddSpan.style.display = 'inline';
                    }
                    if (matchedButton) {
                      matchedButton.classList.remove('active');
                    }
                  }
                }
              });
            });
      }, 1500); 
    }

    // Handle the click on the "+ Add Best Match Thread" button
    if (event.target && event.target.closest('.best-match-add')) {
      console.log("Best Match Thread button clicked");

      const button = event.target.closest('button'); // Get the clicked button

      const variantId = button.getAttribute('data-variant-id'); // Get the variant ID
      const parentTitle = button.getAttribute('data-parent-title'); // Get the parent product title

      // Prepare data for the AJAX request to add the product to the cart
      const formData = {
        items: [{
          id: variantId, // The variant ID of the product
          quantity: 1,   // Set the quantity to 1 (can be changed if needed)
          properties: {
            '_bestMatchFor': parentTitle // Custom property to track the matching product
          }
        }]
      };

      // Send the AJAX request to Shopify's cart add endpoint
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        console.log('Product added to the cart:', data);

        // Optionally, update the UI (e.g., show a success message)

        // Redirect to the cart page after adding the product
        setTimeout(function() {
          window.location.href = '/cart'; // This will redirect to the cart page
        }, 500); // Delay for 1 second before redirecting
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
      });
    }

    if (!window.location.href.includes('cart')) {
      // Handle clicks on the "remove" button for cart items
      if (event.target && event.target.closest('.cart__item__remove')) {
        console.log("Remove button clicked");
  
        // You can add any logic here before redirecting (optional)
        console.log("Redirecting to /cart...");
  
        // Force a page refresh with a delay
        setTimeout(function() {
          window.location.href = '/cart'; // This will redirect to the cart page
        }, 1000); // Delay for 1 second before redirecting
      }
  
      // Handle clicks on the quantity button in the cart item
      if (event.target && event.target.closest('.cart__item__quantity-plus')) {
        // Force a page refresh with a delay
        setTimeout(function() {
          window.location.href = '/cart'; // This will redirect to the cart page
        }, 2000); // Delay for 1 second before redirecting
      }

      if (event.target && event.target.closest('.cart__item__quantity-minus')) {
        // Force a page refresh with a delay
        setTimeout(function() {
          window.location.href = '/cart'; // This will redirect to the cart page
        }, 2000); // Delay for 1 second before redirecting
      }
    }

    
  });
});


// Fix for letter spacing issue in Safari browsers with Swym toast notifications
function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

if (isSafari()) {
  const style = document.createElement('style');
  
  style.innerHTML = `
    #swym-component-container .swym-emphasis {
      font-family: "Circular Medium" !important;
      letter-spacing: -1px !important;
    }
  `;
  
  document.head.appendChild(style);
}

document.addEventListener('DOMContentLoaded', function () {
  function isMobile() {
    return window.matchMedia("(max-width: 768px)").matches;
  }


  function toggleStickyDisplay(isVisible) {
    const stickyElement = document.querySelector('.product__submit__holder--sticky');
    if (stickyElement) {
        stickyElement.style.display = isVisible ? 'none' : 'block';
    }
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (isMobile()) {
          const stickyElement = document.querySelector('.product__submit__holder--sticky');
          const targetElement = document.querySelector('.product__submit__holder--not-sticky');

          const isMainButtonVisible = entry.isIntersecting;

          // Get the position of the main add-to-cart button
          const targetRect = targetElement.getBoundingClientRect();
          const isScrolledPastMainButton = window.scrollY > targetRect.bottom;

          if (!isMainButtonVisible && isScrolledPastMainButton) {
            toggleStickyDisplay(false);
          } else {
            toggleStickyDisplay(true);
          }
        }
    });
  }, {
    threshold: 0 
  });

  const targetElement = document.querySelector('.product__submit__holder--not-sticky');
  if (targetElement) {
    observer.observe(targetElement);
  }
})